import React, { useState, useRef, useEffect } from "react";
import Switch from "react-switch";
import Baseurl from "../../../Baseurl";
import axios from "axios";
import swal from "sweetalert";
import { Spinner } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import { MapContainer, TileLayer, Marker, useMapEvents } from "react-leaflet";
import { AiOutlineArrowLeft } from "react-icons/ai";
import Select from "./Select";
function AddMarkerToClick(props) {
  const [lat, setLat] = useState(0);
  const [lng, setLng] = useState(0);
  useEffect(() => {
    props.setMapShow(false);
    setLat(props.lattitude);
    setLng(props.longitude);
    props.setMapShow(true);
  }, [props.longitude, props.lattitude]);
  const map = useMapEvents({
    click(e) {
      props.setLattitude(e.latlng.lat);
      props.setLongitude(e.latlng.lng);
      props.setMarkerStatus(false);
      setLat(e.latlng.lat);
      setLng(e.latlng.lng);
      //  setTimeout(()=>{
      //   props.setMapShow(false)
      //   props.setMapShow(true)
      //  },500)
    },
  });
  return (
    <>
      <Marker position={[lat, lng]}></Marker>
    </>
  );
}
export default function ViewUpdateWareHouse(props) {
  const { id, type } = props.match.params;
  const history = useHistory();
  const mapRef = useRef(null);
  const [name, setName] = useState("");
  const [cityName, setCityName] = useState("");
  const [storeId, setStoreId] = useState();
  const [address, setAddress] = useState("");
  const [lattitude, setLattitude] = useState(0);
  const [longitude, setLongitude] = useState(0);
  const [phoneNumber, setPhoneNumber] = useState();
  const [auto, setAuto] = useState(false);
  const [mapShow, setMapShow] = useState(false);
  const [markerStatus, setMarkerStatus] = useState(false);
  const [spinnerStatus, setSpinnerStatus] = useState(false);
  const cityObject = [
    "Bengaluru",
    "Mumbai",
    "Chennai",
    "Hyderabad",
    "Delhi",
    "Kolkotta",
  ];
  useEffect(() => {
    if (type === "Update") {
      setName(history.location.state.Name);
      setAddress(history.location.state.Address);

      setLattitude(history.location.state.Lat);
      setLongitude(history.location.state.Lng);
      setPhoneNumber(history.location.state.Phone);
      setStoreId(history.location.state._id);
      setCityName(history.location.state.CityName)
      setMapShow(true);
      setMarkerStatus(true);
    } else {
      setMapShow(true);
    }
  }, []);

  function addItems(e) {
    e.preventDefault();
    let article = {
      name: name,
      address: address,
      lat: lattitude,
      lng: longitude,
      phone: phoneNumber,
      cityName: cityName,
    };
    axios
      .post(`${Baseurl.baseurl6}/go-grocery/warehouse/create-warehouse`, article)
      .then((response) => {
        if (response.data.status) {
          history.goBack();
          swal("created", response.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
        } else {
          swal("Oops", response.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
      })
      .catch((err) => {});
  }
function updateItems(e){
  e.preventDefault();
  let article = {
    name: name,
    address: address,
    lat: lattitude,
    lng: longitude,
    phone: phoneNumber,
    cityName: cityName,
  };
  axios
    .put(`${Baseurl.baseurl6}/go-grocery/warehouse/update-warehouse-details/${storeId}`, article)
    .then((response) => {
      if (response.data.status) {
        history.goBack();
        swal("updated", response.data.message, "success", {
          button: "Done",
          timer: 1000,
        });
      } else {
        swal("Oops", response.data.message, "error", {
          button: "Done",
          timer: 1000,
        });
      }
    })
    .catch((err) => {});
}
  return (
    <div className="mb-5">
      <AiOutlineArrowLeft
        onClick={() => {
          history.goBack();
        }}
        className="mb-2"
        size={24}
        style={{ cursor: "pointer", color: "black" }}
      />
      <div className="basic-form">
        <div className="row">
          <div className="col-sm-2 mt-2">
            <label>
              WareHouse Name <span className="text-danger">*</span>
            </label>
          </div>
          <div className="col-sm-4">
            <input
              value={name}
              type="text"
              className="form-control"
              placeholder="enter WareHouse Name"
              onChange={(e) => setName(e.target.value)}
              required
            />
          </div>
          <div className="col-sm-2 mt-2">
            <label>
              Phone Number <span className="text-danger">*</span>
            </label>
          </div>
          <div className="col-sm-4">
            <input
              value={phoneNumber}
              type="phone"
              className="form-control"
              placeholder="enter phone number"
              maxLength={10}
              onChange={(e) => setPhoneNumber(e.target.value)}
              required
            />
          </div>
        </div>

        <div className="row mt-4 mb-4">
          <div className="col-sm-2">
            <label className="mt-2">Auto Select Location</label>
          </div>
          <div className="col-sm-4 mt-1">
            <Switch
              onColor="#135334"
              onChange={() => {
                setMapShow(false);
                setAuto(!auto);
                if (!auto) {
                  let location = null;
                  if (window.navigator && window.navigator.geolocation) {
                    location = window.navigator.geolocation;
                  }
                  if (location) {
                    location.getCurrentPosition(function (position) {
                      setLattitude(position.coords.latitude);
                      setLongitude(position.coords.longitude);
                      setMapShow(true);
                    });
                  }
                } else {
                  setMapShow(true);
                  setLattitude(0);
                  setLongitude(0);
                }
              }}
              checked={auto}
            />
          </div>
          <div className="col-sm-2 mt-2">
            <label>
              Address <span className="text-danger">*</span>
            </label>
          </div>
          <div className="col-sm-4">
            <textarea
              value={address}
              type="text"
              className="form-control"
              placeholder="enter address"
              onChange={(e) => setAddress(e.target.value)}
              required
            />
          </div>
        </div> <div className="text-center" style={{fontSize:'14px'}}>
                click in the map for Lattitude & Longitude Selection
            </div>

        {mapShow && (
          <MapContainer
            ref={mapRef}
            style={{
              height: window.innerHeight / 2,
              width: window.innerWidth / 1.38,
            }}
            center={[lattitude, longitude]}
            bounds={[lattitude, longitude]}
            zoom={30}
            scrollWheelZoom={true}
          >
            <AddMarkerToClick
              setMapShow={setMapShow}
              lattitude={lattitude}
              longitude={longitude}
              setLattitude={setLattitude}
              setLongitude={setLongitude}
              setMarkerStatus={setMarkerStatus}
            />
            <TileLayer
              url="//{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}"
              maxZoom={21}
              minZoom={4}
              minZoomIsDrawing={18}
              subdomains={["mt0", "mt1", "mt2", "mt3"]}
            />
            {markerStatus && (
              <Marker position={[lattitude, longitude]}></Marker>
            )}
          </MapContainer>
        )}
        <div
          className="text-center mt-3"
          style={{ fontSize: "19px", fontWeight: "600" }}
        >
          OR{" "}
        </div>
        <div
          className="text-center mt-3"
          style={{ fontSize: "16px", fontWeight: "600" }}
        >
          Add Lattitude and Longitude of WareHouse manually{" "}
        </div>
        <div className="row mt-4">
          <div className="col-sm-2 mt-2">
            <label>
              Lattitude<span className="text-danger">*</span>
            </label>
          </div>
          <div className="col-sm-4">
            <input
              value={lattitude}
              type="number"
              className="form-control"
              placeholder="enter lattitude"
              onChange={(e) => setLattitude(e.target.value)}
              required
              onWheel={(e) => e.target.blur()}
            />
          </div>
          <div className="col-sm-2 mt-2">
            <label>Longitude</label>
          </div>
          <div className="col-sm-4">
            <input
              type="number"
              className="form-control"
              id="val-username"
              name="val-username"
              value={longitude}
              onChange={(e) => setLongitude(e.target.value)}
              placeholder="Enter longitude"
              onWheel={(e) => e.target.blur()}
            />
          </div>
        </div>

        <div className="row mt-4">
          <div className="col-sm-2">
              <label className="col-form-label" htmlFor="val-confirm-password">
               Select City
              </label>
            </div>
            <div className="col-sm-4">
              <Select value={cityName} options={cityObject} setValues={setCityName} />
            </div>
        </div>

        {type !== "Update"?(
          <div className="text-center">
            {spinnerStatus ? (
              <Spinner animation="border" variant="primary" />
            ) : (
              <button
                onClick={(e) => {
                  setSpinnerStatus(true);
                  addItems(e);
                }}
                className="btn btn-primary mt-5"
              >
                Submit
              </button>
            )}
          </div>
        ):(
          <div className="text-center">
          {spinnerStatus ? (
            <Spinner animation="border" variant="primary" />
          ) : (
            <button
              onClick={(e) => {
                setSpinnerStatus(true);
                updateItems(e)
              }}
              className="btn btn-primary mt-5"
            >
              Update
            </button>
          )}
        </div>
        )}
      </div>
    </div>
  );
}
